import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

type TabsContainerAttributes = {
  panel?: boolean;
};

export const TabsContainer = styled.div(
  ({ panel }: TabsContainerAttributes) => css`
    position: relative;
    z-index: 1;

    ${panel &&
    css`
      > :not(:first-child) {
        max-height: 260px;
      }
    `}
  `
);

type TabListContainerAttributes = {
  $hidden?: boolean;
};

export const TabListContainer = styled.div(
  ({ $hidden }: TabListContainerAttributes) => css`
    overflow: auto hidden;
    padding: 0px 16px 8px;

    margin-bottom: 4px;
    position: relative;

    display: block;
    width: 100%;

    ${$hidden &&
    css`
      display: none;
    `}
  `
);

export const TabListContent = styled.div`
  align-items: center;
  position: relative;
  width: fit-content;

  display: flex;
  gap: 8px;
`;

export const TabStyledContainer = styled.div`
  font-size: ${Theme.rems(11)};
  color: ${Theme.color.brown};
  letter-spacing: 0.11px;
  line-height: 140%;

  > label:last-child {
    white-space: nowrap;
    text-align: center;

    margin-top: 2px;
    display: block;
  }
`;

type TabStyledAttributes = {
  isActive: boolean;
  shuffle?: boolean;
};

export const TabStyled = styled.div(
  ({ isActive, shuffle }: TabStyledAttributes) => css`
    transition: background-color 0.3s, color 0.3s;
    color: ${Theme.color.orange};
    background-color: #fff1cc;

    border-radius: 50%;
    position: relative;

    display: block;
    padding: 12px;

    height: 48px;
    width: 48px;

    ${isActive &&
    css`
      background-color: ${Theme.color.orange};
      color: ${Theme.color.brown};
    `};

    ${shuffle &&
    css`
      background-color: #fff0f0;
      color: ${Theme.color.red};
    `};
  `
);

export const TabPanelStyled = styled.div`
  overflow: hidden auto;
  min-height: 170px;
  max-height: 170px;
  padding: 0px 16px;

  :has(> div.accessories) {
    padding: 4px 16px 8px;
  }

  &:nth-child(2) {
    overflow: unset;
  }
`;
